import CustomModal from "~components/CustomModal";
import { ErrorContent, ErrorModalProps } from "./ErrorModal";
import { Stack, Text } from "flicket-ui";
import AnimatedLoadingSpinner from "~features/single-page-checkout/components/AnimatedLoadingSpinner/AnimatedLoadingSpinner";
import { useRouter } from "next/router";
import { useEffect } from "react";

export const PrechargeSubmitModal = ({
  isOpen,
  error,
  onClose,
  orderId,
}: ErrorModalProps & {
  isOpen: boolean;
  orderId?: string;
}) => {
  const router = useRouter();

  const onAnimationComplete = () => {
    if (orderId) {
      setTimeout(() => {
        void router.push("/checkout/[orderId]", `/checkout/${orderId}`);
      }, 200);
    }
  };

  useEffect(() => {
    if (orderId) {
      // Only wait 300ms for the animation to complete before falling back and calling it manually.
      setTimeout(() => {
        onAnimationComplete();
      }, 300);
    }
  }, [orderId]);

  return (
    <CustomModal isOpen={isOpen} close={onClose}>
      {error && <ErrorContent error={error} onClose={onClose} />}
      {!error && (
        <Stack
          direction="vertical"
          gap={1}
          alignItems={"center"}
          justifyContent={"center"}
          height="386px"
          p={1}
        >
          <Text variant="header.M" textAlign={"center"}>
            Locking in your best price...
          </Text>
          <AnimatedLoadingSpinner
            loading={!orderId}
            onComplete={onAnimationComplete}
          />
        </Stack>
      )}
    </CustomModal>
  );
};
